import React from 'react';
import { ReactComponent as ErrorPhoto } from '~/Assets/error.svg';
import {style} from './styles';
import { Button, GlobalStyles } from '@mui/material';
const AppCrashedComponent = () => {

  return (
    <>
    <GlobalStyles styles={style} />
    <div className={"root"}>
      <ErrorPhoto height="50%" width="50%" />
      <h2>Oops !! ... Something went wrong</h2>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          window.location = '/';
        }}
      >
        Click Here to go home
      </Button>
    </div>
    </>
  );
};

export default AppCrashedComponent;
